<p [innerHTML]="content" [ngClass]="{'small-text': contentType === 'small-text'}"></p>
